import { Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutAuthorizationStatusList extends Layout {
    table1: Table;
}
